/**
 * @file    HistoryFilters.css
 *
 *          Stylesheet for the HistoryFilters component.
 *
 * @author  Kevin Yu <kevin@distributive.network>
 * @date    March 2024
 */

.history-filters {
  background-color: var(--content-hue-bg);
  padding: 15px 25px 25px 20px;
  display: grid;
  grid-template-columns: 3fr 1fr;
  align-items: end;
  gap: 35px;
  height: fit-content;
  grid-column-start: 1;
}

@media only screen and (max-width: 1280px) {
  .history-filters {
    grid-template-columns: 1fr;
  }
}

.history-filters select,
.history-filters input {
  border: 1px solid var(--content-hue-light);
  height: 33px;
  background-color: white;
  padding: 5px 10px;
  font-size: 0.9rem;
  cursor: pointer;
  color: var(--content-hue-main);

  &:focus-visible {
    border-color: #000;
  }
}

.history-filters-account-select {
  width: 100%;
  min-width: 200px;
  max-width: 360px;
}

@media only screen and (max-width: 640px) {
  .history-filters-account-select {
    max-width: none;
    min-width: auto;
  }
}

.history-filters label {
  color: var(--primary-hue-main);
  font-weight: bold;
}

.history-filters-dropdowns {
  display: flex;
  justify-content: start;
  column-gap: 80px;
  row-gap: 35px;
}

@media only screen and (max-width: 1280px) {
  .history-filters-dropdowns {
    justify-content: flex-start;
  }
}

.history-filters-query-btns {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
}

@media only screen and (max-width: 1280px) {
  .history-filters-dropdowns {
    flex-wrap: wrap;
  }
  .history-filters-query-btns {
    justify-content: flex-start;
  }
}

@media only screen and (max-width: 640px) {
  .history-filters-query-btns {
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
  }

  .history-filters-dropdowns {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}

.history-filters-transaction-types {
  max-width: 250px;
  width: 100%;
}

@media only screen and (max-width: 640px) {
  .history-filters-dates-container {
    flex-direction: column;
    align-items: start;
    gap: 10px;
  }
}

.history-filters-transaction-types,
.history-filters-account-select,
.history-filters-date-range {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
}

@media only screen and (max-width: 640px) {
  .history-filters-transaction-types,
  .history-filters-date-range,
  .history-filters-dates-container,
  .history-filters-search {
    width: 100%;
    max-width: none;
  }
}

.history-filters-dates-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

@media only screen and (max-width: 640px) {
  .history-filters-dates-container {
    flex-direction: column;
    align-items: start;
    gap: 10px;
  }
}

.history-filters-dates-container span {
  font-size: 0.688rem;
  font-weight: bold;
}

@media only screen and (max-width: 640px) {
  .history-filters-dates-container input {
    width: 100%;
  }
}
